import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
const firebaseConfig = {
	apiKey: "AIzaSyD2M0gMatoEGiYh1x_huT-QjaanzcSiZh8",
	authDomain: "freedom-virtual-solutions.firebaseapp.com",
	databaseURL: "https://freedom-virtual-solutions-default-rtdb.firebaseio.com",
	projectId: "freedom-virtual-solutions",
	storageBucket: "freedom-virtual-solutions.appspot.com",
	messagingSenderId: "560536142501",
	appId: "1:560536142501:web:8bb5092ac82a017477834c",
	measurementId: "G-4M4ZWR9LRL",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;
